import { lazy } from 'react';
import { D as DefaultTranslationComp } from './en-US-CWe_aZNZ.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const translationImports = {
  'ar-AE': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--ar-AE" */'./ar-AE-DdkK1SrC.js'),
  'de-DE': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--de-DE" */'./de-DE-BvgbJxMa.js'),
  'en-AU': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--en-AU" */'./en-AU-DeNmaNDY.js'),
  'en-CA': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--en-CA" */'./en-CA-BhoiEV3r.js'),
  'en-GB': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--en-GB" */'./en-GB-BLSnhlbR.js'),
  'en-IN': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--en-IN" */'./en-IN-CnbHYIbU.js'),
  'en-SG': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--en-SG" */'./en-SG-Bjt1rZFI.js'),
  'es-CO': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--es-CO" */'./es-CO-BF7SNtIn.js'),
  'es-ES': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--es-ES" */'./es-ES-DVlnuFHJ.js'),
  'es-MX': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--es-MX" */'./es-MX-D3zfj0UW.js'),
  'fr-CA': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--fr-CA" */'./fr-CA-BtYEzone.js'),
  'fr-FR': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--fr-FR" */'./fr-FR-BPzT5tCX.js'),
  'hi-IN': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--hi-IN" */'./hi-IN-W52JdmIN.js'),
  'it-IT': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--it-IT" */'./it-IT-YelsiU1X.js'),
  'ja-JP': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--ja-JP" */'./ja-JP-BQBtzRDq.js'),
  'ko-KR': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--ko-KR" */'./ko-KR-DrJTAO2E.js'),
  'nl-NL': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--nl-NL" */'./nl-NL-jlgyqjLt.js'),
  'pl-PL': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--pl-PL" */'./pl-PL-CNtRbw7N.js'),
  'pt-BR': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--pt-BR" */'./pt-BR-CHod8DYe.js'),
  'sv-SE': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--sv-SE" */'./sv-SE-BOYjYbWX.js'),
  'ta-IN': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--ta-IN" */'./ta-IN-DD1VdDTC.js'),
  'th-TH': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--th-TH" */'./th-TH-CktDzOb9.js'),
  'tr-TR': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--tr-TR" */'./tr-TR-zpu3-yzY.js'),
  'vi-VN': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--vi-VN" */'./vi-VN-CncXCTvE.js'),
  'zh-CN': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--zh-CN" */'./zh-CN-DIMJH8Tp.js'),
  'zh-TW': () => import(/* webpackChunkName: "storm-ui-page-header--PageHeader--zh-TW" */'./zh-TW-CQ5s4ST9.js')
};
const translationComps = Object.entries(translationImports).reduce((acc, [localCode, importFn]) => ({
  ...acc,
  [localCode]: /*#__PURE__*/lazy(importFn)
}), {});
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : DefaultTranslationComp,
    locale: locale && locale in translationComps ? locale : 'en-US',
    translationImports
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=index-D-JlEl92.js.map
